
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/leftBar/openedLeftPanels/openedLeftPanels.scss.css.virtualfile';
        module.exports = {"panel":"_panel_1lyq5_7","opened":"_opened_1lyq5_22"};